import OriginLocationManagementComponent from 'components/desktop/StandingData/OriginLocation/Management/OriginLocationManagementComponent';

const OriginLocationManagementContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<OriginLocationManagementComponent />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default OriginLocationManagementContainer;
